import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronRight } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useCallback, useMemo, useState } from "react";
import { DEFAULT_AMOUNT_OF_CUSTOM_FIELDS_TO_SHOW } from "~/components/AssetModalV2/constants";
import { useCollapsibleSectionsContext } from "~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider";
import { CollapsibleSection } from "~/components/AssetModalV2/InfoPanel/components/CollapsibleSection";
import { CUSTOM_FIELDS_SECTION } from "~/components/AssetModalV2/InfoPanel/CustomFields/PrivateCustomFieldsCollapsibleSection";
import { AssetCustomFieldsPanelContent } from "~/components/RightPanel/CustomFields/AssetCustomFieldsPanelContent";
import { PublicAssetPanelCustomFieldDateInput } from "~/components/RightPanel/CustomFields/PublicAssetPanelCustomFieldDateInput";
import { PublicAssetPanelCustomFieldPlainText } from "~/components/RightPanel/CustomFields/PublicAssetPanelCustomFieldPlainText";
import { PublicAssetPanelCustomFieldSelect } from "~/components/RightPanel/CustomFields/PublicAssetPanelCustomFieldSelect";
import { usePublicAssetCustomFieldsData } from "~/hooks/usePublicAssetCustomFieldsData";
export const PublicCustomFieldsCollapsibleSection = /*#__PURE__*/ memo(()=>{
    const { data: customFields } = usePublicAssetCustomFieldsData();
    const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
    const isExpanded = expandedSections["customFields"];
    const [showRestOfFields, setShowRestOfFields] = useState(false);
    const firstThreeFields = customFields === null || customFields === void 0 ? void 0 : customFields.data.slice(0, DEFAULT_AMOUNT_OF_CUSTOM_FIELDS_TO_SHOW);
    const restOfFields = customFields === null || customFields === void 0 ? void 0 : customFields.data.slice(DEFAULT_AMOUNT_OF_CUSTOM_FIELDS_TO_SHOW);
    const firstThreeFieldsRender = useMemo(()=>{
        return /*#__PURE__*/ _jsx(AssetCustomFieldsPanelContent, {
            fields: firstThreeFields,
            SelectCustomField: PublicAssetPanelCustomFieldSelect,
            DateCustomField: PublicAssetPanelCustomFieldDateInput,
            PlainTextCustomField: PublicAssetPanelCustomFieldPlainText
        });
    }, [
        firstThreeFields
    ]);
    const restOfFieldsRender = useMemo(()=>{
        return /*#__PURE__*/ _jsx(AssetCustomFieldsPanelContent, {
            fields: restOfFields,
            SelectCustomField: PublicAssetPanelCustomFieldSelect,
            DateCustomField: PublicAssetPanelCustomFieldDateInput,
            PlainTextCustomField: PublicAssetPanelCustomFieldPlainText
        });
    }, [
        restOfFields
    ]);
    const handleOnClick = useCallback(()=>{
        setShowRestOfFields((prev)=>!prev);
    }, []);
    const onOpenChange = useCallback(()=>{
        toggleSection("customFields");
    }, [
        toggleSection
    ]);
    return /*#__PURE__*/ _jsxs(CollapsibleSection, {
        title: "Custom Fields",
        isExpanded: isExpanded,
        onOpenChange: onOpenChange,
        "data-testid": CUSTOM_FIELDS_SECTION,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mx-1",
                children: firstThreeFieldsRender
            }),
            !!(restOfFields === null || restOfFields === void 0 ? void 0 : restOfFields.length) && /*#__PURE__*/ _jsx(Button, {
                onClick: handleOnClick,
                size: "small",
                appearance: "ghost",
                color: "grey",
                suffix: showRestOfFields ? /*#__PURE__*/ _jsx(ChevronDown, {
                    className: "size-4"
                }) : /*#__PURE__*/ _jsx(ChevronRight, {
                    className: "size-4"
                }),
                "data-testid": "TOGGLE_CUSTOM_FIELDS_BUTTON",
                children: /*#__PURE__*/ _jsx("span", {
                    children: showRestOfFields ? "Hide All Fields" : "See All Fields"
                })
            }),
            showRestOfFields && !!(restOfFields === null || restOfFields === void 0 ? void 0 : restOfFields.length) && /*#__PURE__*/ _jsx("div", {
                className: "mx-1",
                children: restOfFieldsRender
            })
        ]
    });
});
PublicCustomFieldsCollapsibleSection.displayName = "PublicCustomFieldsCollapsibleSection";
